import { createPortal } from 'react-dom';
var Portal = function(param) {
    var children = param.children, _param_container = param.container, container = _param_container === void 0 ? document.body : _param_container;
    return /*#__PURE__*/ createPortal(children, container);
};
export default Portal;
